const Asian_1=[
    {
        "Contig_Num":"8",
        "Contig_Len":"815220684",
        "GC":"38.95",
        "Scaffold_Num":"8",
        "Scaffold_Len":"815220684",
        "Gap_Num":"0",
        "Gap_Len":"0"
    }
]
export default Asian_1